import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createGatePass } from '../../../../redux/actions/SocietyPortal/VmsAction/VmsAction';
import { selectedSocietyStorer } from '../../../../utils/webStorer';
import { notify } from '../../../../utils/notification';
import { SOCIETY_PORTAL, SOCIETY_PORTAL_GATE_PASSES } from '../../../../Routing/routes';
import GatePassForm from './GatePassForm';

const AddGatePass = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const societyId = selectedSocietyStorer.getSocietyId();
    const saving = useSelector(state => state.VmsReducer?.gatePasses?.saving);

    const backToList = () => navigate(SOCIETY_PORTAL + SOCIETY_PORTAL_GATE_PASSES);

    const handleSubmit = (payload) => {
        if (!societyId) {
            notify('error', 'No society selected. Pick a society before issuing a pass.');
            return;
        }
        dispatch(createGatePass({ ...payload, onSuccess: backToList }));
    };

    return (
        <div className="tw-p-5 tw-bg-gradient-to-br tw-from-gray-50 tw-to-slate-50 tw-min-h-screen">
            <div className="tw-w-full">
                <button
                    onClick={backToList}
                    className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-gray-600 hover:tw-text-gray-800 tw-mb-3"
                >
                    <Icon icon="mdi:arrow-left" /> Back to Gate Passes
                </button>

                <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm">
                    <div className="tw-p-4 tw-border-b tw-border-gray-100">
                        <h1 className="tw-mb-0 tw-text-base tw-font-bold tw-text-gray-800">Issue Gate Pass</h1>
                        <p className="tw-mb-0 tw-text-[11px] tw-text-gray-500 tw-mt-0.5">
                            A standing authorisation for a visitor who is already registered
                        </p>
                    </div>
                    <div className="tw-p-5">
                        <GatePassForm
                            mode="create"
                            societyId={societyId}
                            submitting={saving}
                            onSubmit={handleSubmit}
                            onCancel={backToList}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddGatePass;
